import { BanknoteIcon, InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';

export const SalaryAdjustmentLineTypes = {
  Salary: 'salary',
  Adjustment: 'adjustment',
} as const;

export type SalaryAdjustmentLineType =
  (typeof SalaryAdjustmentLineTypes)[keyof typeof SalaryAdjustmentLineTypes];

interface SalaryAdjustmentLineLabelProps {
  type: SalaryAdjustmentLineType;
  isEmpty?: boolean;
}

/** Maps a derived salary-line type to its shared label and explanatory tooltip. */
export function SalaryAdjustmentLineLabel({
  type,
  isEmpty = false,
}: SalaryAdjustmentLineLabelProps) {
  const { t } = useTranslation('authenticated.bills');
  const isSalary = type === SalaryAdjustmentLineTypes.Salary;
  const label = t(isSalary ? 'monthlySalary.salaryOnlyLabel' : 'monthlySalary.adjustmentLabel');
  const tooltip = t(
    isEmpty && !isSalary
      ? 'monthlySalary.emptyAdjustmentTooltip'
      : isSalary
        ? 'monthlySalary.salaryOnlyTooltip'
        : 'monthlySalary.adjustmentTooltip'
  );

  return (
    <div className="flex min-w-0 items-center gap-2">
      <BanknoteIcon size={16} className="shrink-0 text-muted-foreground" />
      <span className="truncate text-sm font-medium">{label}</span>
      <SimpleTooltip content={tooltip} contentClassName="max-w-xs">
        <InfoIcon size={14} className="shrink-0 cursor-help text-muted-foreground" />
      </SimpleTooltip>
    </div>
  );
}
